// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/images/check-mark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg width=%2724px%27 height=%2724px%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M18.5303 9.46967C18.8232 9.76256 18.8232 10.2374 18.5303 10.5303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17678 6.23744 9.17678 6.53033 9.46967L12 14.9393L17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967Z%27 fill=%27%23030D45%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Poppins", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.tooltip-inner {
  background: #4a5568;
  font-family: Poppins, sans-serif;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding: 2px 5px 1px 5px;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  max-width: 300px;
}
.tooltip-inner p {
  margin: 0;
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  line-height: 18px;
}
.tooltip-inner p span {
  display: list-item;
  margin-left: 20px;
}

.tooltip-fw .tooltip-inner {
  max-width: 100%;
}

.darkTooltip .tooltip-inner {
  background: #333;
}
.darkTooltip.bs-tooltip-top .arrow::before {
  border-top-color: #333;
}

.emailTooltip .tooltip-inner {
  max-width: none;
}

.bs-tooltip-bottom .arrow::before {
  bottom: 0;
  right: 3px;
  border-bottom-color: #4a5568;
  border-width: 3px;
}

.bs-tooltip-top .arrow::before {
  border-top-color: #4a5568;
}

.bs-tooltip-left .arrow::before {
  border-left-color: #4a5568;
}

.bs-tooltip-right .arrow::before {
  border-right-color: #4a5568;
}

.modal-content {
  background: #ffffff;
  box-shadow: 0px 23px 26px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
}
.modal-content .modal-header {
  border: none;
  padding: 12px 12px 0px 30px;
}
.modal-content .modal-header .modal-title {
  font-family: Poppins, sans-serif;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.5px;
  color: #333333;
  margin-top: 10px;
}
.modal-content .modal-header .close {
  color: #182c4f;
  opacity: unset;
  font-weight: normal;
}
.modal-content .modal-body {
  padding: 24px 30px 0px 30px;
}
.modal-content .modal-body .form-label {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #4c4c4c;
  margin-bottom: 9px;
}
.modal-content .modal-body .form-row .form-group .form-control {
  background: #ffffff;
  border: 1px solid #c2cfff;
  border-radius: 4px;
  padding: 12px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.modal-content .modal-footer {
  border: none;
  padding: 0px 30px 18px;
}

.form-row {
  justify-content: space-between;
}

.form-control.is-invalid {
  background-image: unset;
}

.DateInput_input {
  font-size: 15px;
  line-height: 15px;
  padding: 7px 6px 6px;
}

.DateInput {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  align-items: center;
  color: #bfbfbf;
}

.completedFilterModal .SingleDatePickerInput_calendarIcon {
  right: 0;
  position: absolute;
}

.SingleDatePicker {
  width: 100%;
  margin-bottom: 32px;
}

.SingleDatePickerInput {
  width: 100%;
}
.SingleDatePickerInput .DateInput_1 {
  width: 100%;
}

.bgvHomeModalContainer .modal-dialog {
  margin: 0 auto;
}
.bgvHomeModalContainer .modal-content {
  border: none;
  border-radius: 0;
}

.react-switch {
  vertical-align: middle;
  margin-left: 4px;
}

.countryCodeDropDown {
  flex: 0 0 25%;
  max-width: 25%;
}

.basic-details-form .fullName:focus,
.add-edit-education-form .fullName:focus {
  border: 2px solid #2755fe !important;
  box-shadow: none !important;
}
.basic-details-form .invalid-feedback,
.add-edit-education-form .invalid-feedback {
  font-size: 14px;
  font-weight: 600;
  color: #f5222d;
}

.countries .select__control {
  border: 1px solid #ebedf2 !important;
  box-sizing: border-box;
  border-radius: 4px;
}

.customSelectSearch:focus {
  border: none;
  box-shadow: none;
  outline: 0;
}

.countryCodesModal {
  padding: 0 !important;
}
@media only screen and (max-width: 600px) {
  .countryCodesModal {
    margin: 0;
  }
}
.countryCodesModal .modal-dialog {
  width: 100%;
  max-width: none;
  height: 100%;
  margin: 0;
}
.countryCodesModal .modal-content {
  height: auto;
  min-height: 100vh;
  width: 100vh;
  border: 0;
  border-radius: 0;
}
.countryCodesModal .modal-header {
  border: none;
  padding: 12px 12px 0px 30px;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.countryCodesModal .modal-body {
  padding: 0 !important;
  overflow-y: auto;
}

.verificationModal {
  top: 86px;
}
@media only screen and (max-width: 600px) {
  .verificationModal {
    top: auto;
    margin: 0;
  }
}
.verificationModal .modal-content {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  min-height: 580px;
}
.verificationModal .modal-header .close {
  font-size: xx-large;
}
.verificationModal .customSearchIcon {
  padding: 6px !important;
}

.empFilesModal {
  top: 86px;
}
@media only screen and (max-width: 600px) {
  .empFilesModal {
    top: auto;
    margin: 0;
  }
}
.empFilesModal .modal-content {
  padding: 32px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}
.empFilesModal .modal-content .modal-header {
  padding: 0;
}
.empFilesModal .modal-content .modal-body {
  padding: 0;
}
@media only screen and (max-width: 600px) {
  .empFilesModal .modal-content .modal-body {
    min-height: 66vh;
  }
}
@media only screen and (max-width: 600px) {
  .empFilesModal .modal-content {
    padding: 16px;
    min-height: 100vh;
  }
  .empFilesModal .modal-footer {
    padding: 0;
    margin-top: 29px;
  }
}

.currently_working label {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 22px;
  color: #595959 !important;
}

.detailsStartDate .SingleDatePicker .SingleDatePickerInput {
  width: 100%;
}
.detailsStartDate .SingleDatePicker .SingleDatePickerInput .DateInput_1 {
  width: 80%;
}
@media only screen and (max-width: 600px) {
  .detailsStartDate .SingleDatePicker {
    margin-bottom: 0px;
  }
  .detailsStartDate .SingleDatePicker .SingleDatePickerInput {
    width: 100%;
  }
  .detailsStartDate .SingleDatePicker .SingleDatePickerInput .DateInput_1 {
    width: 80%;
  }
}

.empDateError .react-datepicker-wrapper {
  border: 1px solid #dc3545 !important;
  border-radius: 4px;
}

.empEndDateContainer .react-datepicker-wrapper {
  width: 100%;
}

.educationModal {
  top: 86px;
}
.educationModal.adcApproveModal {
  top: auto !important;
}
@media only screen and (max-width: 600px) {
  .educationModal {
    top: auto;
    margin: 0;
  }
}
.educationModal .modal-content {
  padding: 32px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}
.educationModal .modal-content .modal-header {
  padding: 0;
  margin-bottom: 24px;
}
.educationModal .modal-content .modal-body {
  padding: 0;
}
@media only screen and (max-width: 600px) {
  .educationModal .modal-content {
    padding: 16px;
    min-height: 100vh;
  }
  .educationModal .modal-footer {
    padding: 0;
    margin-top: 29px;
  }
}

.empDatePicker input {
  border: 1px solid #dc3545;
}

.react-datepicker__close-icon::after {
  background-color: #cccccc !important;
}

.imagePreviewModal {
  background: rgba(0, 0, 0, 0.9);
}
.imagePreviewModal .modal-content {
  background: transparent;
  border: none;
  box-shadow: none;
}
.imagePreviewModal .close {
  color: #ffffff !important;
}
.imagePreviewModal .close span {
  font-size: 59px;
}

.bgvCameraModalContainer .modal-dialog {
  margin: 0;
}
.bgvCameraModalContainer .modal-content {
  background: linear-gradient(180deg, #a8ccd7 0%, #151515 100%);
  height: 100vh;
  border-radius: 0;
  border: none;
}
.bgvCameraModalContainer .modal-header {
  background: #000000;
  height: 45px;
}
.bgvCameraModalContainer .modal-body {
  padding: 16px 16px 0 16px;
  align-content: center;
  display: flex;
}
.bgvCameraModalContainer .modal-body video {
  width: 100%;
}
.bgvCameraModalContainer .modal-footer {
  text-align: center;
  width: 100%;
  background: #000000;
  padding-top: 18px;
  justify-content: center;
}

.bgvCameraErrorModalContainer .modal-dialog {
  margin: 0;
}
.bgvCameraErrorModalContainer .modal-content {
  height: 100vh;
  border-radius: 0;
  border: none;
  padding: 16px;
}
.bgvCameraErrorModalContainer .modal-header {
  padding: 0;
}
.bgvCameraErrorModalContainer .modal-body {
  padding: 16px 0;
}
.bgvCameraErrorModalContainer .modal-footer {
  padding: 0;
}

.bgvProgressBar {
  width: 140px;
  height: 7px;
  border-radius: 0px;
}
@media only screen and (max-width: 600px) {
  .bgvProgressBar {
    width: 100%;
  }
}
.bgvProgressBar .progress-bar {
  background-color: #2755fe;
  opacity: 0.8;
}

.customBGVModalBackdrop {
  background-color: rgba(0, 6, 28, 0.8);
  opacity: 1 !important;
}

.widgetsInputValue {
  height: 100% !important;
  border: none !important;
}

.adminCardAccess {
  box-shadow: none !important;
  border: 1px solid #ebedf2 !important;
  border-radius: 4px !important;
  height: 38px !important;
  width: 100% !important;
}
.adminCardAccess .rw-input {
  color: #4c4c4c !important;
  background-color: var(--white) !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-weight: 600 !important;
}

.serviceDropdownContainer .serviceDropdown {
  width: 180px !important;
  height: 20px !important;
  padding: 0px !important;
  box-shadow: none !important;
  border: 1px solid #ebedf2 !important;
  border-radius: 4px !important;
  position: relative;
  bottom: 5px;
}
.serviceDropdownContainer .serviceDropdown .rw-input {
  color: #4c4c4c !important;
  background-color: var(--white) !important;
  font-size: 14px !important;
  font-weight: normal !important;
}
.serviceDropdownContainer .rw-popup-container .rw-list {
  font-size: 14px !important;
}

.widgetDropdownTimeContainer {
  border: none !important;
  height: 100% !important;
}

.widgetDropdownTimeContainer .rw-placeholder {
  color: #333 !important; /* Change this to your desired color */
  opacity: 1 !important;
}

.widgetDropdownTimeContainer .rw-input {
  color: #333 !important; /* Change this to your desired color */
}

.widgetDropdownTimeContainer .rw-dropdown-list-autofill {
  color: #333 !important; /* Change this to your desired color */
}

.customisePackageModal {
  top: 86px;
}
@media only screen and (max-width: 600px) {
  .customisePackageModal {
    top: auto;
    margin: 0;
  }
}
.customisePackageModal .modal-content {
  padding: 32px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}
.customisePackageModal .modal-content .modal-header {
  padding: 0;
  margin-bottom: 24px;
}
.customisePackageModal .modal-content .modal-body {
  padding: 0;
}
@media only screen and (max-width: 600px) {
  .customisePackageModal .modal-content {
    padding: 16px;
    min-height: 100vh;
  }
  .customisePackageModal .modal-footer {
    padding: 0;
    margin-top: 29px;
  }
}

.confirmationModalBackdrop {
  background-color: rgba(0, 6, 28, 0.8);
  opacity: 1 !important;
  z-index: 1050;
}

.passwordProtectedModalBackdrop {
  background-color: rgba(0, 6, 28, 0.8);
  opacity: 0 !important;
  z-index: 1050;
}

.customFieldGreenhouse {
  background-color: rgb(0, 0, 0);
  opacity: 0.6 !important;
}

.passwordProtectedModal {
  top: 86px;
}
@media only screen and (max-width: 600px) {
  .passwordProtectedModal {
    margin: 0px;
    top: auto;
  }
}

.paymentDocument .react-pdf__Page__canvas {
  margin: 0 auto;
  width: 100% !important;
  height: 100% !important;
  border-radius: 5px;
}

.rupee {
  font-family: "roboto";
}

.custom-checkbox-style-1,
.custom-radio-style-1 {
  padding: 0;
}
.custom-checkbox-style-1 .custom-control-label,
.custom-radio-style-1 .custom-control-label {
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #212529 !important;
  margin-bottom: 0 !important;
  font-weight: 500 !important;
  padding-left: 32px;
}
.custom-checkbox-style-1 .custom-control-label::before,
.custom-radio-style-1 .custom-control-label::before {
  width: 20px;
  height: 20px;
  border: 2px solid #2755fe;
  border-radius: 2px;
  top: 0;
  left: 0;
  box-shadow: none !important;
}
.custom-checkbox-style-1 .custom-control-label::after,
.custom-radio-style-1 .custom-control-label::after {
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  border-radius: 2px;
}
.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::before,
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2755fe;
  background: #fff;
  box-shadow: none;
}
.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::after,
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {
  background: #2755fe;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;
}
.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label,
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::before,
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::after,
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {
  opacity: 0.6;
}
.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label,
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before,
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after,
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {
  opacity: 0.6;
  background-color: #666666;
}

.custom-radio-style-1 .custom-control-label {
  cursor: pointer;
  margin-bottom: 0 !important;
}
.custom-radio-style-1 .custom-control-label::before {
  border-radius: 100%;
}
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2755fe;
  background: #fff;
}
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {
  width: 10px;
  height: 10px;
  background: #2755fe;
  border-radius: 100%;
  left: 5px;
  top: 5px;
}
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {
  opacity: 0.6;
}
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
  background-color: transparent;
}
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {
  opacity: 0.6;
  background: #666666;
}

.cardBorder {
  box-shadow: 0px 0px 13px rgba(82, 103, 65, 0.16);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.customDatePicker .SingleDatePicker {
  height: 37px;
  margin-bottom: 0px !important;
}
.customDatePicker .SingleDatePickerInput__withBorder {
  border: 1px solid #dfe1e5 !important;
  border-radius: 4px;
}
.customDatePicker .DateInput_1 {
  width: 305px;
}
.customDatePicker .SingleDatePickerInput_calendarIcon {
  height: 27px;
  padding-top: 1px;
}

.custom-select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/15px 20px;
  background-color: #f4f6ff;
}

.rw-placeholder {
  font-weight: 400;
  opacity: 0.6;
  font-size: 16px;
}

.custom-checkbox-style {
  padding: 0;
}
.custom-checkbox-style .custom-control-label {
  cursor: pointer;
  color: #333333 !important;
  font-size: 14px !important;
  font-family: Poppins !important;
  font-weight: 400 !important;
  line-height: 21px !important;
  word-wrap: break-word !important;
  padding-left: 20px !important;
}
.custom-checkbox-style .custom-control-label::before {
  width: 16px;
  height: 16px;
  border: 2px solid #2755fe;
  border-radius: 2px;
  top: 2px;
  left: 0;
  box-shadow: none !important;
}
.custom-checkbox-style .custom-control-label::after {
  width: 16px;
  height: 16px;
  top: 2px;
  left: 0;
  border-radius: 2px;
}
.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2755fe;
  background: #fff;
  box-shadow: none;
}
.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::after {
  background: #2755fe;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;
}
.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::after {
  opacity: 0.6;
}
.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::after {
  opacity: 0.6;
  background-color: #666666;
}

.swiper-custom .swiper {
  height: 150px !important;
}
.swiper-custom .swiper-wrapper {
  transition-timing-function: linear;
}

.upSellTooltip .tooltip-inner {
  border-radius: 4px;
  background: rgba(224, 224, 224, 0.5);
  color: #666;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 5px 7px;
  box-shadow: none !important;
}
.upSellTooltip .arrow {
  display: none !important;
}

.reactWidgetCustomDp .rw-placeholder {
  font-weight: 400;
  opacity: 1;
  font-size: 14px;
  color: #333 !important;
}
.reactWidgetCustomDp .rw-placeholder span {
  color: #333 !important;
}
.reactWidgetCustomDp .rw-input,
.reactWidgetCustomDp .rw-dropdown-list-autofill,
.reactWidgetCustomDp .rw-filter-input {
  color: #333 !important;
}

/* For Firefox */
input[type=number] {
  /* Hide the up and down arrows */
  -moz-appearance: textfield;
}

/* For Microsoft Edge */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  /* Hide the up and down arrows */
  -webkit-appearance: none;
  margin: 0;
}

/* For IE */
input[type=number] {
  /* Hide the up and down arrows */
  -ms-overflow-style: none;
  appearance: textfield; /* Hides arrows in IE10 and IE11 */
}

input[type=radio],
input[type=checkbox] {
  accent-color: #2755fe;
}

.addCandidateModal .modal-dialog {
  max-width: 628px !important;
}
.addCandidateModal .modal-body {
  padding: 24px 23px 0px 23px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,yKAAyK;EACzK,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;AACX;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;AACA;EACE;IACE,SAAS;IACT,SAAS;EACX;AACF;AACA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;AACA;EACE;IACE,SAAS;IACT,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,SAAS;IACT,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;AACA;EACE,6DAA6D;EAC7D,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB,EAAE,sCAAsC;EAC9D,qBAAqB;AACvB;;AAEA;EACE,sBAAsB,EAAE,sCAAsC;AAChE;;AAEA;EACE,sBAAsB,EAAE,sCAAsC;AAChE;;AAEA;EACE,SAAS;AACX;AACA;EACE;IACE,SAAS;IACT,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;AACA;EACE;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,yDAAqD;EACrD,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4FAAmlB;EACnlB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yDAAqD;EACrD,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;;EAEE,gCAAgC;EAChC,wBAAwB;EACxB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,wBAAwB;EACxB,qBAAqB,EAAE,kCAAkC;AAC3D;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Poppins\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.tooltip-inner {\n  background: #4a5568;\n  font-family: Poppins, sans-serif;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);\n  border-radius: 2px;\n  padding: 2px 5px 1px 5px;\n  font-size: 14px;\n  line-height: 21px;\n  color: #ffffff;\n  max-width: 300px;\n}\n.tooltip-inner p {\n  margin: 0;\n  display: flex;\n  justify-content: flex-start;\n  font-size: 12px;\n  line-height: 18px;\n}\n.tooltip-inner p span {\n  display: list-item;\n  margin-left: 20px;\n}\n\n.tooltip-fw .tooltip-inner {\n  max-width: 100%;\n}\n\n.darkTooltip .tooltip-inner {\n  background: #333;\n}\n.darkTooltip.bs-tooltip-top .arrow::before {\n  border-top-color: #333;\n}\n\n.emailTooltip .tooltip-inner {\n  max-width: none;\n}\n\n.bs-tooltip-bottom .arrow::before {\n  bottom: 0;\n  right: 3px;\n  border-bottom-color: #4a5568;\n  border-width: 3px;\n}\n\n.bs-tooltip-top .arrow::before {\n  border-top-color: #4a5568;\n}\n\n.bs-tooltip-left .arrow::before {\n  border-left-color: #4a5568;\n}\n\n.bs-tooltip-right .arrow::before {\n  border-right-color: #4a5568;\n}\n\n.modal-content {\n  background: #ffffff;\n  box-shadow: 0px 23px 26px rgba(0, 0, 0, 0.16);\n  border-radius: 5px;\n}\n.modal-content .modal-header {\n  border: none;\n  padding: 12px 12px 0px 30px;\n}\n.modal-content .modal-header .modal-title {\n  font-family: Poppins, sans-serif;\n  font-weight: normal;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0.5px;\n  color: #333333;\n  margin-top: 10px;\n}\n.modal-content .modal-header .close {\n  color: #182c4f;\n  opacity: unset;\n  font-weight: normal;\n}\n.modal-content .modal-body {\n  padding: 24px 30px 0px 30px;\n}\n.modal-content .modal-body .form-label {\n  font-family: Poppins, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  color: #4c4c4c;\n  margin-bottom: 9px;\n}\n.modal-content .modal-body .form-row .form-group .form-control {\n  background: #ffffff;\n  border: 1px solid #c2cfff;\n  border-radius: 4px;\n  padding: 12px;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: #333333;\n}\n.modal-content .modal-footer {\n  border: none;\n  padding: 0px 30px 18px;\n}\n\n.form-row {\n  justify-content: space-between;\n}\n\n.form-control.is-invalid {\n  background-image: unset;\n}\n\n.DateInput_input {\n  font-size: 15px;\n  line-height: 15px;\n  padding: 7px 6px 6px;\n}\n\n.DateInput {\n  font-family: Poppins, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  align-items: center;\n  color: #bfbfbf;\n}\n\n.completedFilterModal .SingleDatePickerInput_calendarIcon {\n  right: 0;\n  position: absolute;\n}\n\n.SingleDatePicker {\n  width: 100%;\n  margin-bottom: 32px;\n}\n\n.SingleDatePickerInput {\n  width: 100%;\n}\n.SingleDatePickerInput .DateInput_1 {\n  width: 100%;\n}\n\n.bgvHomeModalContainer .modal-dialog {\n  margin: 0 auto;\n}\n.bgvHomeModalContainer .modal-content {\n  border: none;\n  border-radius: 0;\n}\n\n.react-switch {\n  vertical-align: middle;\n  margin-left: 4px;\n}\n\n.countryCodeDropDown {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.basic-details-form .fullName:focus,\n.add-edit-education-form .fullName:focus {\n  border: 2px solid #2755fe !important;\n  box-shadow: none !important;\n}\n.basic-details-form .invalid-feedback,\n.add-edit-education-form .invalid-feedback {\n  font-size: 14px;\n  font-weight: 600;\n  color: #f5222d;\n}\n\n.countries .select__control {\n  border: 1px solid #ebedf2 !important;\n  box-sizing: border-box;\n  border-radius: 4px;\n}\n\n.customSelectSearch:focus {\n  border: none;\n  box-shadow: none;\n  outline: 0;\n}\n\n.countryCodesModal {\n  padding: 0 !important;\n}\n@media only screen and (max-width: 600px) {\n  .countryCodesModal {\n    margin: 0;\n  }\n}\n.countryCodesModal .modal-dialog {\n  width: 100%;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.countryCodesModal .modal-content {\n  height: auto;\n  min-height: 100vh;\n  width: 100vh;\n  border: 0;\n  border-radius: 0;\n}\n.countryCodesModal .modal-header {\n  border: none;\n  padding: 12px 12px 0px 30px;\n  font-family: Poppins, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: #333333;\n}\n.countryCodesModal .modal-body {\n  padding: 0 !important;\n  overflow-y: auto;\n}\n\n.verificationModal {\n  top: 86px;\n}\n@media only screen and (max-width: 600px) {\n  .verificationModal {\n    top: auto;\n    margin: 0;\n  }\n}\n.verificationModal .modal-content {\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  min-height: 580px;\n}\n.verificationModal .modal-header .close {\n  font-size: xx-large;\n}\n.verificationModal .customSearchIcon {\n  padding: 6px !important;\n}\n\n.empFilesModal {\n  top: 86px;\n}\n@media only screen and (max-width: 600px) {\n  .empFilesModal {\n    top: auto;\n    margin: 0;\n  }\n}\n.empFilesModal .modal-content {\n  padding: 32px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n}\n.empFilesModal .modal-content .modal-header {\n  padding: 0;\n}\n.empFilesModal .modal-content .modal-body {\n  padding: 0;\n}\n@media only screen and (max-width: 600px) {\n  .empFilesModal .modal-content .modal-body {\n    min-height: 66vh;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .empFilesModal .modal-content {\n    padding: 16px;\n    min-height: 100vh;\n  }\n  .empFilesModal .modal-footer {\n    padding: 0;\n    margin-top: 29px;\n  }\n}\n\n.currently_working label {\n  font-family: Poppins, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px !important;\n  line-height: 22px;\n  color: #595959 !important;\n}\n\n.detailsStartDate .SingleDatePicker .SingleDatePickerInput {\n  width: 100%;\n}\n.detailsStartDate .SingleDatePicker .SingleDatePickerInput .DateInput_1 {\n  width: 80%;\n}\n@media only screen and (max-width: 600px) {\n  .detailsStartDate .SingleDatePicker {\n    margin-bottom: 0px;\n  }\n  .detailsStartDate .SingleDatePicker .SingleDatePickerInput {\n    width: 100%;\n  }\n  .detailsStartDate .SingleDatePicker .SingleDatePickerInput .DateInput_1 {\n    width: 80%;\n  }\n}\n\n.empDateError .react-datepicker-wrapper {\n  border: 1px solid #dc3545 !important;\n  border-radius: 4px;\n}\n\n.empEndDateContainer .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.educationModal {\n  top: 86px;\n}\n.educationModal.adcApproveModal {\n  top: auto !important;\n}\n@media only screen and (max-width: 600px) {\n  .educationModal {\n    top: auto;\n    margin: 0;\n  }\n}\n.educationModal .modal-content {\n  padding: 32px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n}\n.educationModal .modal-content .modal-header {\n  padding: 0;\n  margin-bottom: 24px;\n}\n.educationModal .modal-content .modal-body {\n  padding: 0;\n}\n@media only screen and (max-width: 600px) {\n  .educationModal .modal-content {\n    padding: 16px;\n    min-height: 100vh;\n  }\n  .educationModal .modal-footer {\n    padding: 0;\n    margin-top: 29px;\n  }\n}\n\n.empDatePicker input {\n  border: 1px solid #dc3545;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: #cccccc !important;\n}\n\n.imagePreviewModal {\n  background: rgba(0, 0, 0, 0.9);\n}\n.imagePreviewModal .modal-content {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n.imagePreviewModal .close {\n  color: #ffffff !important;\n}\n.imagePreviewModal .close span {\n  font-size: 59px;\n}\n\n.bgvCameraModalContainer .modal-dialog {\n  margin: 0;\n}\n.bgvCameraModalContainer .modal-content {\n  background: linear-gradient(180deg, #a8ccd7 0%, #151515 100%);\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n}\n.bgvCameraModalContainer .modal-header {\n  background: #000000;\n  height: 45px;\n}\n.bgvCameraModalContainer .modal-body {\n  padding: 16px 16px 0 16px;\n  align-content: center;\n  display: flex;\n}\n.bgvCameraModalContainer .modal-body video {\n  width: 100%;\n}\n.bgvCameraModalContainer .modal-footer {\n  text-align: center;\n  width: 100%;\n  background: #000000;\n  padding-top: 18px;\n  justify-content: center;\n}\n\n.bgvCameraErrorModalContainer .modal-dialog {\n  margin: 0;\n}\n.bgvCameraErrorModalContainer .modal-content {\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  padding: 16px;\n}\n.bgvCameraErrorModalContainer .modal-header {\n  padding: 0;\n}\n.bgvCameraErrorModalContainer .modal-body {\n  padding: 16px 0;\n}\n.bgvCameraErrorModalContainer .modal-footer {\n  padding: 0;\n}\n\n.bgvProgressBar {\n  width: 140px;\n  height: 7px;\n  border-radius: 0px;\n}\n@media only screen and (max-width: 600px) {\n  .bgvProgressBar {\n    width: 100%;\n  }\n}\n.bgvProgressBar .progress-bar {\n  background-color: #2755fe;\n  opacity: 0.8;\n}\n\n.customBGVModalBackdrop {\n  background-color: rgba(0, 6, 28, 0.8);\n  opacity: 1 !important;\n}\n\n.widgetsInputValue {\n  height: 100% !important;\n  border: none !important;\n}\n\n.adminCardAccess {\n  box-shadow: none !important;\n  border: 1px solid #ebedf2 !important;\n  border-radius: 4px !important;\n  height: 38px !important;\n  width: 100% !important;\n}\n.adminCardAccess .rw-input {\n  color: #4c4c4c !important;\n  background-color: var(--white) !important;\n  font-size: 14px !important;\n  font-weight: normal !important;\n  font-weight: 600 !important;\n}\n\n.serviceDropdownContainer .serviceDropdown {\n  width: 180px !important;\n  height: 20px !important;\n  padding: 0px !important;\n  box-shadow: none !important;\n  border: 1px solid #ebedf2 !important;\n  border-radius: 4px !important;\n  position: relative;\n  bottom: 5px;\n}\n.serviceDropdownContainer .serviceDropdown .rw-input {\n  color: #4c4c4c !important;\n  background-color: var(--white) !important;\n  font-size: 14px !important;\n  font-weight: normal !important;\n}\n.serviceDropdownContainer .rw-popup-container .rw-list {\n  font-size: 14px !important;\n}\n\n.widgetDropdownTimeContainer {\n  border: none !important;\n  height: 100% !important;\n}\n\n.widgetDropdownTimeContainer .rw-placeholder {\n  color: #333 !important; /* Change this to your desired color */\n  opacity: 1 !important;\n}\n\n.widgetDropdownTimeContainer .rw-input {\n  color: #333 !important; /* Change this to your desired color */\n}\n\n.widgetDropdownTimeContainer .rw-dropdown-list-autofill {\n  color: #333 !important; /* Change this to your desired color */\n}\n\n.customisePackageModal {\n  top: 86px;\n}\n@media only screen and (max-width: 600px) {\n  .customisePackageModal {\n    top: auto;\n    margin: 0;\n  }\n}\n.customisePackageModal .modal-content {\n  padding: 32px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n}\n.customisePackageModal .modal-content .modal-header {\n  padding: 0;\n  margin-bottom: 24px;\n}\n.customisePackageModal .modal-content .modal-body {\n  padding: 0;\n}\n@media only screen and (max-width: 600px) {\n  .customisePackageModal .modal-content {\n    padding: 16px;\n    min-height: 100vh;\n  }\n  .customisePackageModal .modal-footer {\n    padding: 0;\n    margin-top: 29px;\n  }\n}\n\n.confirmationModalBackdrop {\n  background-color: rgba(0, 6, 28, 0.8);\n  opacity: 1 !important;\n  z-index: 1050;\n}\n\n.passwordProtectedModalBackdrop {\n  background-color: rgba(0, 6, 28, 0.8);\n  opacity: 0 !important;\n  z-index: 1050;\n}\n\n.customFieldGreenhouse {\n  background-color: rgb(0, 0, 0);\n  opacity: 0.6 !important;\n}\n\n.passwordProtectedModal {\n  top: 86px;\n}\n@media only screen and (max-width: 600px) {\n  .passwordProtectedModal {\n    margin: 0px;\n    top: auto;\n  }\n}\n\n.paymentDocument .react-pdf__Page__canvas {\n  margin: 0 auto;\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 5px;\n}\n\n.rupee {\n  font-family: \"roboto\";\n}\n\n.custom-checkbox-style-1,\n.custom-radio-style-1 {\n  padding: 0;\n}\n.custom-checkbox-style-1 .custom-control-label,\n.custom-radio-style-1 .custom-control-label {\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #212529 !important;\n  margin-bottom: 0 !important;\n  font-weight: 500 !important;\n  padding-left: 32px;\n}\n.custom-checkbox-style-1 .custom-control-label::before,\n.custom-radio-style-1 .custom-control-label::before {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #2755fe;\n  border-radius: 2px;\n  top: 0;\n  left: 0;\n  box-shadow: none !important;\n}\n.custom-checkbox-style-1 .custom-control-label::after,\n.custom-radio-style-1 .custom-control-label::after {\n  width: 20px;\n  height: 20px;\n  top: 0;\n  left: 0;\n  border-radius: 2px;\n}\n.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::before,\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #2755fe;\n  background: #fff;\n  box-shadow: none;\n}\n.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::after,\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {\n  background: #2755fe;\n  background-image: url(\"../src/images/check-mark.svg\");\n  background-position: center center;\n  background-size: 80%;\n  background-repeat: no-repeat;\n}\n.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label,\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::before,\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::after,\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n}\n.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label,\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before,\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after,\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n  background-color: #666666;\n}\n\n.custom-radio-style-1 .custom-control-label {\n  cursor: pointer;\n  margin-bottom: 0 !important;\n}\n.custom-radio-style-1 .custom-control-label::before {\n  border-radius: 100%;\n}\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #2755fe;\n  background: #fff;\n}\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {\n  width: 10px;\n  height: 10px;\n  background: #2755fe;\n  border-radius: 100%;\n  left: 5px;\n  top: 5px;\n}\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n}\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n  background-color: transparent;\n}\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n  background: #666666;\n}\n\n.cardBorder {\n  box-shadow: 0px 0px 13px rgba(82, 103, 65, 0.16);\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.customDatePicker .SingleDatePicker {\n  height: 37px;\n  margin-bottom: 0px !important;\n}\n.customDatePicker .SingleDatePickerInput__withBorder {\n  border: 1px solid #dfe1e5 !important;\n  border-radius: 4px;\n}\n.customDatePicker .DateInput_1 {\n  width: 305px;\n}\n.customDatePicker .SingleDatePickerInput_calendarIcon {\n  height: 27px;\n  padding-top: 1px;\n}\n\n.custom-select {\n  background: url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='24px' height='24px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.5303 9.46967C18.8232 9.76256 18.8232 10.2374 18.5303 10.5303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17678 6.23744 9.17678 6.53033 9.46967L12 14.9393L17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967Z' fill='%23030D45'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/15px 20px;\n  background-color: #f4f6ff;\n}\n\n.rw-placeholder {\n  font-weight: 400;\n  opacity: 0.6;\n  font-size: 16px;\n}\n\n.custom-checkbox-style {\n  padding: 0;\n}\n.custom-checkbox-style .custom-control-label {\n  cursor: pointer;\n  color: #333333 !important;\n  font-size: 14px !important;\n  font-family: Poppins !important;\n  font-weight: 400 !important;\n  line-height: 21px !important;\n  word-wrap: break-word !important;\n  padding-left: 20px !important;\n}\n.custom-checkbox-style .custom-control-label::before {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #2755fe;\n  border-radius: 2px;\n  top: 2px;\n  left: 0;\n  box-shadow: none !important;\n}\n.custom-checkbox-style .custom-control-label::after {\n  width: 16px;\n  height: 16px;\n  top: 2px;\n  left: 0;\n  border-radius: 2px;\n}\n.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #2755fe;\n  background: #fff;\n  box-shadow: none;\n}\n.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::after {\n  background: #2755fe;\n  background-image: url(\"../src/images/check-mark.svg\");\n  background-position: center center;\n  background-size: 80%;\n  background-repeat: no-repeat;\n}\n.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n}\n.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n  background-color: #666666;\n}\n\n.swiper-custom .swiper {\n  height: 150px !important;\n}\n.swiper-custom .swiper-wrapper {\n  transition-timing-function: linear;\n}\n\n.upSellTooltip .tooltip-inner {\n  border-radius: 4px;\n  background: rgba(224, 224, 224, 0.5);\n  color: #666;\n  font-family: Poppins;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 5px 7px;\n  box-shadow: none !important;\n}\n.upSellTooltip .arrow {\n  display: none !important;\n}\n\n.reactWidgetCustomDp .rw-placeholder {\n  font-weight: 400;\n  opacity: 1;\n  font-size: 14px;\n  color: #333 !important;\n}\n.reactWidgetCustomDp .rw-placeholder span {\n  color: #333 !important;\n}\n.reactWidgetCustomDp .rw-input,\n.reactWidgetCustomDp .rw-dropdown-list-autofill,\n.reactWidgetCustomDp .rw-filter-input {\n  color: #333 !important;\n}\n\n/* For Firefox */\ninput[type=number] {\n  /* Hide the up and down arrows */\n  -moz-appearance: textfield;\n}\n\n/* For Microsoft Edge */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  /* Hide the up and down arrows */\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For IE */\ninput[type=number] {\n  /* Hide the up and down arrows */\n  -ms-overflow-style: none;\n  appearance: textfield; /* Hides arrows in IE10 and IE11 */\n}\n\ninput[type=radio],\ninput[type=checkbox] {\n  accent-color: #2755fe;\n}\n\n.addCandidateModal .modal-dialog {\n  max-width: 628px !important;\n}\n.addCandidateModal .modal-body {\n  padding: 24px 23px 0px 23px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
